export const paidniceGreen700 = `#2B495A`;
